import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export function ProtectedRoute({children}) {
  const { session, loading } = useSelector((state) => state.auth);

  if (loading) {
    return <div>Cargando autenticación (Redux)...</div>; 
  }

  if (!session) {
    return <Navigate to="/login" replace />; 
  }

  return children
}